// extracted by mini-css-extract-plugin
module.exports = {"section":"Home_section__IYouY","container_div":"Home_container_div__3TmOd","heading":"Home_heading__1iRE5","btn_container":"Home_btn_container__1qPW1"};